// const skills = [
//   "MERN",
//   "UI UX",
//   "Adobe Illustrator",
//   "Canva",
//   "Adobe Photoshop",
//   "Figma",
//   "Java",
//   "github",
//   "Confidence",
//   "Creativity",
//   "Communication",
//   "Empathy",
//   "Organisation",
//   "Management",
// ];

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image: "./assets/Icon (4).png",
      },

      {
        name: "HTML",
        image: "./assets/Icon (12).png",
      },
      {
        name: "JavaScript",
        image: "./assets/New Project.png",
      },
      {
        name: "Bootstrap",
        image: "./assets/BootstrapIcon.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "./assets/Icon (5).png",
      },
      {
        name: "Express Js",
        image: "./assets/express (1).png",
      },

      {
        name: "MongoDB",
        image: "./assets/Icon (7).png",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Java",
        image: "./assets/Icon (3).png",
      },
      {
        name: "GitHub",
        image: "./assets/Icon (6).png",
      },

      {
        name: "Microsoft Azure Cloud",
        image: "./assets/icon (8).png",
      },

      {
        name: "Machine Learning",
        image: "./assets/icon (10).png",
      },
      {
        name: "Figma",
        image: "./assets/icon (13).png",
      },
      {
        name: "Microsoft Power Platform",
        image: "./assets/icon (9).png",
      },
    ],
  },
];

export const projects = [
  {
    id: 0,
    title: "Blog Website",
    date: "Jun 2024 - Dec 2024",
    description:
      "A full stack blog website where users can write blogs and read blogs. It has a simple user authentication system and is built with React JS for the frontend and Node JS with Express JS for the backend. MongoDB is used as the database to store user data and blog posts.",
    image: "./assets/projects/BlogWebsite.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Microsoft Azure",
      "Vercel",
      "Render",
      "Github",
    ],
    category: "web app",
    github: "https://github.com/Devika0713/books-blog-frontend",
    webapp: "https://books-blog-frontend-eight.vercel.app/",
  },
  {
    id: 1,
    title: "Cinema Journal",
    date: "Feb 2025 - May 2025",
    description:
      "As an avid binge watcher, I created a Cinema Journal to keep track of all the movies and TV shows I watch.It is built with React JS for the frontend and Node JS with Express JS for the backend, using MongoDB as the database and TMBD api to fetch details of movies and TV shows.",
    image: "./assets/projects/CinemaJournal.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "TMDB API",
      "Vercel",
      "Render",
      "Github",
    ],
    category: "web app",
    github: "https://github.com/Devika0713/cinemaJournal-frontend",
    webapp: "https://cinema-journal-frontend.vercel.app/",
  },
  {
    id: 2,
    title: "Solar spectrum",
    date: "Apr 2023 - Apr 2024",
    description:
      "As a part of my final year project, me and my team built a data science solution that predicts the occurrence and intensity of sunspots and solar activities such as coronal mass ejections and solar flares within a solar cycle using time-based models such as LSTM and GRU . The results are then displayed on a website as interactive graphs. ",
    image: "./assets/projects/solarSpectrum.png",
    tags: ["Machine Learning", "Python", "HTML", "Javascript"],
    category: "Machine Learning",
    // github: "https://github.com/rishavchanda/Project-Management-App",
    // webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 3,
    title: "Keeper app",
    date: "Jun 2021 - Sep 2021",
    description:
      "I crafted a Google Keep replica in Anjela Yu's web development bootcamp. I gained hands-on experience in React and elevated my skills through practical application.",
    image: "./assets/projects/Keeper.png",
    tags: ["React"],
    category: "Web app",
    github: "https://github.com/Devika0713/keeper_app",
    webapp: "https://x1upv.csb.app/",
  },
  {
    id: 4,
    title: "Dall e clone",
    date: "Dec 2022 - Apr 2023",
    description:
      "A Dall e clone built with React JS, Node JS, Express JS and MongoDB. It allows users to generate images from text prompts using OpenAI's Dall e API.",
    image: "./assets/projects/dalle.png",
    tags: [
      "React",
      "Tailwind CSS",
      "Node Js",
      "Express Js",
      "MongoDB",
      "OpenAI API",
    ],
    category: "Web app",
    github: "https://github.com/Devika0713/Dall-e2.0",
    webapp: "",
  },
];
